import Axios from 'axios'
import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import config from '../../config'
import routes from '../../routes'
import { SIZES } from '../../styles/theme'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.register.landscape});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0;
  padding-bottom: 2em;
  padding-top: 2em;
  color: #bc1b27;
  text-align: center;

  .row {
    .error-message {
      font-weight: 500;
      color: #000000;
    }

    .register-form {
      padding: 2.5em 0;
      position: absolute;
      left: 37%;
      right: 32%;
      top: 12%;

      ${SIZES.mobile} {
        margin-top: 18%;
        position: initial;
        @media screen and (min-width: 768px) {
          margin-top: 14%;
          position: absolute;
          left: 9%;
          right: 5%;
          top: 12%;
        }
      }

      .form-group {
        width: auto;
        margin: 8px auto;
        box-shadow: 0 5px 4px -4px #000000;
        background: #ffffff;
        border: none;
        border-radius: 25px;
        text-align: center;
        padding-right: 16px;
        label {
          padding: 0 8px;
          margin: 0 auto;
          padding-right: 0;
          font-size: 13px;
        }
        .required:before {
          content: '* ';
          color: red;
        }
        input[type='tel'],
        .form-input {
          display: block;
          color: #484848;
          width: 100%;
          font-weight: 500;
          background: transparent;
          border: none;
          padding: 4px 24px;
          outline: none;
          text-align: center;
        }
      }
      #password {
        width: 12px;
        margin: 2px 4px;
      }
    }
  }
  ${SIZES.mobile} {
    background-image: url(${config.assets.register.portrait});
    padding: 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    min-height: 100vh;
    background-size: 100% 100%;
    @media only screen and (min-width: 768px) {
      font-size: auto;
    }
  }

  button.submit-btn {
    background: linear-gradient(#da2a3a, #ac1723);
    box-shadow: 0 5px 4px -4px #000000;
    width: 40%;
    color: #ffffff;
    font-weight: 500;
    border: 3px solid #ffffff;
    border-radius: 56px;
    display: flex;
    justify-content: center;
    padding: 8px 24px;
    margin: 16px auto;
    margin-bottom: 0;
    font-size: 1em;
    outline: none;

    ${SIZES.mobile} {
      width: 60%;
      padding: 10px 24px;
    }

    &:disabled {
      cursor: not-allowed;
      background: grey;
      border: 3px solid #ffffff;
    }

    div {
      line-height: 32px;
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [industry, setIndustry] = useState('')
  const [companyName, setCompanyName] = useState('')

  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    const options = {
      full_name: fullName.trim(),
      email,
      industry,
      company_name: companyName,
    }
    Axios.post(`${config.apiUrl}/api/register`, options)
      .then(() => {
        setLoading(false)
        history.push(routes.postRegister)
      })
      .catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      })
  }

  const hasEmptyField = !(fullName.length && email.length && industry.length && companyName.length)

  return (
    <Page>
      <Row id="main" noGutters className="px-4 pl-md-0 pt-2 pb-3">
        <Col md={12} className="px-md-4">
          <Row className="register-form py-xs-5" noGutters>
            <Col lg={12} md={12} xs={12}>
              <Form.Group>
                <label className="required">Full Name</label>
                <input className="form-input" required type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <label className="required">Email Address</label>
                <input className="form-input" required type="email" value={email} onChange={handleEmailInput} />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <label className="required">Company Name</label>
                <input className="form-input" required type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <label className="required">Industry</label>
                <input className="form-input" required type="text" value={industry} onChange={(e) => setIndustry(e.target.value)} />
              </Form.Group>
            </Col>

            <div className="w-100 pr-md-4">
              <Button type="submit" className="submit-btn" variant="default" disabled={hasEmptyField || loading} onClick={handleSubmit}>
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
    </Page>
  )
}
